import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Languages_Component } from 'app/layout/common/languages/languages.component';
import { Shared_Module } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        Languages_Component
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        Shared_Module
    ],
    exports     : [
        Languages_Component
    ]
})
export class Languages_Module
{
}
